import React from "react";

import ReusableModal from "components/Modals/ReusableModal";


const DeleteStarterKitComponent = ({
  isOpen,
  onClose,
  onConfirm,
  componentName,
}) => {

  const bodyMessage = `
    Are you sure you want to delete
    <strong>${componentName}</strong>?
    This action cannot be undone.
  `;


  return (
    <ReusableModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Confirm Delete"
      bodyMessage={
        <div
          dangerouslySetInnerHTML={{
            __html: bodyMessage,
          }}
        />
      }
      confirmLabel="Confirm"
      cancelLabel="Cancel"
    />
  );
};


export default DeleteStarterKitComponent;